import React from "react"
import { Container } from "@mui/material"

const VideoBlock = ({ src, poster }) => {
  // Current version is without play button
  return (
    <Container disableGutters maxWidth={false} sx={{ display: `flex` }}>
      <video
        muted
        // onCanPlay={(this.muted = true)}
        loop
        poster={poster} // Placeholder image for browser that don't allow autoplay
        autoPlay
        playsInline
        loading="lazy"
        style={{ width: `100%`, borderTop: `1px solid black` }}
        // controls // enable to allow users to pause the video
      >
        <source src={src} type="video/mp4" />
      </video>
    </Container>
  )
}

export default VideoBlock
